import { render, staticRenderFns } from "./manageBinLabel.vue?vue&type=template&id=cb8b0366&scoped=true"
import script from "./manageBinLabel.vue?vue&type=script&lang=js"
export * from "./manageBinLabel.vue?vue&type=script&lang=js"
import style0 from "./manageBinLabel.vue?vue&type=style&index=0&id=cb8b0366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8b0366",
  null
  
)

export default component.exports